'use client'

import {
  useEffect,
  useRef,
  useState,
  type ReactNode,
  type ReactPortal
} from 'react'
import { createPortal } from 'react-dom'

interface PortalProps {
  children: ReactNode
  getNode?: () => HTMLElement | null
}

function Portal(props: PortalProps): ReactPortal | null {
  const { getNode, children } = props
  const [isMounted, setIsMounted] = useState(false)
  const nodeRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    setIsMounted(true)
    nodeRef.current = getNode?.() ?? null
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isMounted
    ? createPortal(children, nodeRef.current || document.body)
    : null
  // createPortal will not be rendered on the server. Only on the client after hydration
}

export { Portal }
